<template>
      <div style="background-color:#fcfcfc;height:100%">
            <div class="lv1-row1">
                  <!-- Row 1 -->
                  <div class="nav-overlay"></div>
                  <!-- Header -->
                  <div class="row border-bottom">
                        <div class="hamburg-menu mobile-show">
                              <div class="button_container toggle">
                              <span class="top"></span>
                              <span class="middle"></span>
                              <span class="bottom"></span>
                              </div>
                        </div>

                        <nav class="navbar navbar-static-top ob-header" role="navigation" style="margin-bottom: 0">
                              <div class="navbar-header col-xs-12 offset-0">
                                    <ul class="headerStrip">
                                          <li  @click="setProfile" class="side-nav-profile-pic" style="border-right: 1px solid #858688;float: left;width: 18%;">

                                                <a style="display: block;color: #fff;height: 51px;">
                                                      <span class="nav-icon" id="auto_load_div" style="width: 50px;display: block; padding: 6px;">
                                                            <img alt="image" class="profile-pic" :src="profilePic" style="border-radius: 100%; width:100%;height:38px;" />
                                                      </span>
                                                      <span class="nav-label" style="display: block; padding-top: 7px; padding-left: 56px;">
                                                      <span class="user-name userdetails-textellipse" :title="name" style="display: block; width: 140px;text-decoration: none">{{name}}</span>
                                                      <span class="user-designation userdetails-textellipse" :title="designation" style="color:#C4C9D1;">{{designation}}</span>
                                                      </span>
                                                </a>

                                          <div class="logo-element" id="auto_response_div"> </div>
                                          </li>
                                          <li style="float: left;width: 60%;">

                                                <div class="logoBlock"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/BWLogo.png`" /></div>
                                          </li>
                                          <li style="float: right;width: 10%;border-left:1px solid rgb(133, 134, 136)">
                                                <div class="logOut--headerSec">
                                                      <a @click="onSignOut" id="btnsubmit" class="logOut--SettingNoBDR"><i class="fa fa-sign-out" aria-hidden="true"></i><label>Sign Out</label></a>
                                                </div>
                                          </li>



                                    </ul>
                              </div>
                        </nav>

                  </div>
                  <div class="right-sidebarMT"></div>
                  <!--// Header -->
            </div>
            <div class="section">
                  <div class="main-content">
                        <h1 class="heading">SELECT YOUR ORGANIZATION</h1>
                        <div class="org-section">
                              <div class="row-content">
                                    <div v-for="orgRec in orgInfo" class="org-content">
                                          <div v-if="orgRec.IsEssValidated">
                                                <div @click="SelectOrg(orgRec)" class="organization">
                                                      <img :src="orgRec.LogoLink == null || orgRec.LogoLink == '' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/large.svg` : orgRec.LogoLink" alt="organization-logo" height="50px" width="50px" />
                                                      <p class="org-name">{{orgRec.Name}}</p>
                                                      <p class="select-org">SELECT</p>
                                                      <!-- <p class="select-org" v-else @click="verifyPopup">VERIFY</p>                          -->
                                                </div>
                                          </div>
                                          <div v-else>
                                                <div @click="verifyPopup(orgRec)" class="organization">
                                                      <img :src="orgRec.LogoLink == null || orgRec.LogoLink == '' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/large.svg` : orgRec.LogoLink" alt="organization-logo" height="50px" width="50px" />
                                                      <p class="org-name">{{orgRec.Name}}</p>
                                                      <p class="select-org">VERIFY</p>
                                                </div>
                                          </div>
                                    </div>

                              </div>
                        </div>
                  </div>
                  <div class="copy_right">
                        <div style="padding: 0 0 30px; text-align:center"> &copy; {{date}} OnBlick Inc., All rights reserved </div>
                  </div>
            </div>

            <profile-pic-modal :openModal.sync="openprofilemodal" :orgId="orgId"></profile-pic-modal>
            <verify-phone-popup :openModal.sync="openPhonemodal" :EmployeeId="empId" :PhoneNo="phone" :OrgName="orgName"></verify-phone-popup>
            <disabled-organization :openModal.sync="openAlertmodal" :OrgName="disableOrg"></disabled-organization>
      </div>
</template>


<script>
import c from 'Vue/Core/constants.js'
import profileModal from '@/components/ESSProfile/ESSSettings/ProfilePicModal.vue'
import verifyPhoneModal from '@/components/verifyPhonePopup.vue'
import disabledOrganizationModal from '@/components/DisabledOrganization.vue'
export default {
      data() {
            return {
                  date : new Date().getFullYear(),
                  openprofilemodal:false,
                  openPhonemodal:false,
                  empInfo:'',
                  orgInfo:'',
                  profileLink:'',
                  empId:'',
                  orgId:'',
                  phone:'',
                  //Otp:'',
                  orgName:'',
                  openAlertmodal:false,
                  disableOrg:''
            }
      },
       components: {
            "profile-pic-modal": profileModal,
            "verify-phone-popup": verifyPhoneModal,
            "disabled-organization": disabledOrganizationModal
      },
      computed: {
            profilePic() {
                  if (this.empInfo.ProfilePic != null && this.empInfo.ProfilePic != "")
                        return this.empInfo.ProfilePic;
                  else
                        return `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`;
            },
            name() {
                  return loggedInUserObj.name || ''
            },
            designation() {
                  return loggedInUserObj.designation || 'Consultant'
            }

      },
      watch:{

      },
      created() {
            //this.getESSEnabledOrg()
            session.isActive()
            this.organizationList()
            events.listen('profileUpdate',()=>{
            this.organizationList()
            })
            events.listen('verificationSuccess',()=>{
            this.organizationList()
            })
      },
      methods:{
            // getESSEnabledOrg(){
            //       ajax.get(`/Employee/${loggedInUserObj.email}/OnBordedOrganizations`, {}, (res) => {
            //             if(res.data.State == true){
            //                   var employeeOrganizations = res.data.EmployeeOrganizations
            //                   var count = 0;
            //                   var countD = 0;
            //                   var obj = {};
            //                   var obj1 = {};
            //
            //                   console.log(employeeOrganizations.filter((d) => { return d.IsESSEnabled}))
            //                   if(employeeOrganizations != null && employeeOrganizations != ''){
            //                   employeeOrganizations.forEach((e)=>{
            //                   if(e.IsESSEnabled)
            //                         count +=1;
            //                   })
            //                   if (count == 0){
            //                         this.onSignOut()
            //                   }
            //                   else if(count == 1){
            //                         obj = employeeOrganizations.filter((d) => { if(d.IsESSEnabled == true) return d})
            //                         if(obj[0].IsEssValidated == true){
            //                         this.$router.push({'name':'employee-details'})
            //                         }
            //                         else{
            //                         this.$router.push({'name':'SelectOrganization'})
            //                         }
            //                   }
            //                   else if( count > 1 ){

            //                          //select organization page
            //                         obj1 = employeeOrganizations.filter((d) => { if(d.IsESSEnabled == true) return d})
            //                         obj1.forEach((e)=>{
            //                         if(e.IsEssValidated)
            //                         countD +=1;
            //                         })
            //                         if(countD > 0)
            //                         this.$router.push({'name':'employee-details'})
            //                         else
            //                         this.$router.push({'name':'SelectOrganization'})
            //                   }
            //                   }
            //             }
            //       })
            // },
            organizationList(){
                  this.$loading({ 'loadingText': 'Loading...' })
                  // ajax.get(`Employee/${loggedInUserObj.email}/EmployeeOrganizationList`, {}, (res) => {
                  ajax.get(`Employee/${loggedInUserObj.consultantId}/EmployeeOrganizationList`, {}, (res) => {
                        this.$loading({}).close()
                        if (res.data.State == true) {
                        this.empInfo = res.data.organizationBasicInfoList.EmployeeInfo
                        this.orgInfo = res.data.organizationBasicInfoList.OrganizationInfo
                        }
                        else
                        this.ESSEnableDisable(res)
                  })


            },
            SelectOrg(orgRec){
                  this.$loading({ 'loadingText': 'Loading...' })
                  ajax.get(`/Employee/${orgRec.EmployeeId}/IsESSEnabled`, {}, (res) => {
                        if(res.data == false){
                              this.$loading({}).close()
                              this.disableOrg = orgRec.Name
                              this.openAlertmodal = true
                        }
                        else{
                              this.$loading({}).close()
                              ajax.get(`/Employee/GetEmployeeDetails?orgId=${orgRec.Id}`, {}, (res) => {
                                    if (res.data.State == true) {
                                          var userObj = {}
                                          userObj.empId = res.data.EmpId
                                          userObj.name = res.data.EmployeeContact.FirstName + ' ' + res.data.EmployeeContact.LastName
                                          userObj.email = res.data.EmployeeContact.Email
                                          userObj.orgId = res.data.OrgId
                                          userObj.consultantId = res.data.ConsultantId
                                          userObj.profilepic = res.data.ProfilePicLink
                                          userObj.designation = res.data.Designation
                                          userObj.IsH1B = res.data.IsH1B
                                          userObj.OrgName = res.data.OrgName
                                          userObj.OrgWebSite = res.data.OrgWebsite
                                          userObj.HireType = res.data.HireType
                                          //userObj.SelectOrg = true
                                          // Update the employee details in local storage
                                          localStorage.setItem("user_details", JSON.stringify(userObj))

                                          // update the employee details
                                          ajax.updateUserDetails()
                                        //   window.createConnection()
                                           this.$router.push({'name':'ess-dashboard'})
                                           this.$loading({}).close()
                                    }
                                    else{
                                          this.$loading({}).close()
                                          this.ESSEnableDisable(res)
                                    }
                              })
                        }
                  })

            },
            setProfile(){
                  this.orgInfo.forEach(element => {
                        if(element.EmployeeId == this.empInfo.Id){
                              this.orgId = element.Id
                        }
                  });
                   this.openprofilemodal = true
            },
            onSignOut() {
                  ajax.signOut()
            },
            verifyPopup(orgRec){
                  this.empId = orgRec.EmployeeId
                  this.phone = orgRec.Phone
                  this.orgName = orgRec.Name
                  this.$loading({ 'loadingText': 'Loading...' })
                  ajax.get(`Employee/${this.empId}/SendOTPToEmployee`, {}, (res) => {
                        this.$loading({}).close()
                        if (res.data.State == true) {
                              ajax.get(`/Employee/${this.empId}/BasicInfo`, {}, (res) => {
                                    if(res.data.State == true){
                                          this.empData = res.data.Employee
                                          this.phone = this.empData.Phone
                                    }
                                    else
                                          this.ESSEnableDisable(res)
                              })
                              this.openPhonemodal = true
                              //this.Otp = "OTP sent to your registered mobile number"
                        }
                        else{
                              this.ESSEnableDisable(res)
                             // this.Otp = "OTP sent failed"
                        }
                  })
            }
      }
}
</script>
<style scoped>
.heading{
      font-size: 20px;
      color: #143361;
      font-weight: 800;
}
.main-content{
      text-align:center;
      padding: 60px 0 140px;
}
 .section{
      height: inherit;
      overflow:auto;
      padding:0 50px;
}
.row-content{
      width:100%;
      display:inline-block;
}
.org-content{
      width:40%;
      padding:20px 60px;
      display:inline-block
}
.organization{
      background-color: #fff;
      padding: 40px 0 20px;
      box-shadow: 0px 8px 16px 0px rgba(217,219,224,0.3);
      cursor:pointer;
}
.org-name{
      font-size:16px;color: rgb(51, 51, 51);
      padding: 14px 0 24px 0;
}
.select-org{
      font-size:14px;color:rgb(204, 37, 80);
      font-weight: 600;
}
.org-section{
      padding:20px 100px;
}
.copy_right{
      text-align: center;
      font-size: 11px;
      color: #3b3b48;
      font-weight: 600;
      padding:0px 0 60px;
      background: none;
      border-top: none;
      font-family: avenir light, Verdana;
}
.logOut--headerSec a span{
      background: none;

}
.logOut--headerSec{
     padding: 17px 0;
     margin: 0;
}
.logOut--SettingR{
      border-right: none;
}
.logOut--headerSec.middle{
      padding: 0;
}
.logOut--SettingNoBDR{
      margin-right: 25px;
}
.popper{
      width: 250px;
      text-align: left;
}
.popper-section{
      padding: 5px;
}
.org{
      padding: 11px 2px;
}
.org-icon{
      float: left;
      padding-right: 10px;
}
.org-text{
    color: #143361;
    font-size: 13px;
    font-weight: 600;

}
.select-org{
      cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/SelectOrganization.vue